<template>
  <button
    :id="id || customId"
    :name="id || customId"
    :disabled="isDisabled || isLoading"
    :class="['btn', `btn__${theme}`]"
    v-on="{ ...$listeners }"
  >
    <img
      v-if="isLoading"
      :src="loaderURL"
      alt="Carregando.."
    />

    <img
      v-if="icon && !isLoading"
      :src="iconURL"
      :alt="`Ícone ${icon}`"
    />

    <span :class="{'noImg': !icon && !isLoading}">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    icon: { type: String, required: false },
    label: { type: String, required: true },
    theme: { type: String, default: 'default' },
    id: { type: String }
  },
  computed: {
    customId () {
      const hasSpaces = this.label.split(' ')
      const text =
        hasSpaces.length === 1
          ? this.label.toLowerCase()
          : this.label.toLowerCase().split(' ').join('-')
      return `btn-${text}`
    },
    loaderURL () {
      return require(`@/assets/svg/loader.svg`)
    },
    iconURL () {
      return require(`@/assets/svg/icon-${this.icon}.svg`)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  align-items: center;
  border: solid 1px;
  border-radius: 28px;
  cursor: pointer;
  display: flex;
  font-family: Oscine, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  justify-content: flex-start;
  padding: 10px 24px;
  text-align: center;
  transition: filter 0.2s;
  width: fit-content;

  &__default {
    border-color: #C8C8C8;
    color: #444444;
  }

  &__purple {
    border-color: #6320E9;
    color: #6320E9;
  }

  &__purple-filled {
    background-color: #6320E9;
    border-color: #6320E9;
    color: #FFFFFF;

    &:hover {
      color: #FFFFFF;
    }
  }

  &__pink {
    background-color: #FF3796;
    border-color: #FF3796;
    color: #FFFFFF;

    &:hover {
      color: #FFFFFF;
    }
  }

  &__link {
    background-color: transparent;
    border-color: transparent;
    color: #444444;

    &:hover {
      color: #444444;
    }
  }

  &:disabled {
    cursor: no-drop;
    opacity: 0.4;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    filter: brightness(0.9);
  }

  img {
    height: 16px;
    margin-right: 12px;
  }

  span {
    pointer-events: none;

    &.noImg {
      display: inline-block;
      width: 100%;
    }
  }
}
</style>
